// New Plan Pricing Structure - Duration-based plans
// Note: credits can be float values (e.g., 20.5)
export const PLAN_PRICING = {
    // Monthly plans
    "plus_monthly": { "usd": 5, "inr": 400, "credits": 20, "duration_days": 30 },
    "pro_monthly": { "usd": 10, "inr": 800, "credits": 40, "duration_days": 30 },

    // 4 Month plans (15% discount)
    "plus_4months": { "usd": 17, "inr": 1360, "credits": 80, "duration_days": 120 },
    "pro_4months": { "usd": 34, "inr": 2720, "credits": 160, "duration_days": 120 },

    // Yearly plans (20% discount)
    "plus_yearly": { "usd": 48, "inr": 3840, "credits": 240, "duration_days": 365 },
    "pro_yearly": { "usd": 96, "inr": 7680, "credits": 480, "duration_days": 365 },

    // Credit Top-ups (one-time purchases - never expire)
    "topup_monthly": { "usd": 10, "inr": 800, "credits": 40, "duration_days": -1 },
    "topup_4months": { "usd": 34, "inr": 2720, "credits": 160, "duration_days": -1 },
    "topup_yearly": { "usd": 96, "inr": 7680, "credits": 480, "duration_days": -1 },
};

// Legacy plan pricing (for backward compatibility)
export const LEGACY_PRICING = {
    topup_credits_per_dollar: 4,
    topup_amount: 10,
    pro_amount: 10,
    plus_amount: 5,

    topup_credits_per_inr: 1 / 20,
    topup_amount_inr: 800,
    pro_amount_inr: 800,
    plus_amount_inr: 400,

    // Legacy credit allocations (for backward compatibility)
    topup_credits: 40,
    pro_credits: 40,
    plus_credits: 20,
};